import { render } from "./AdminRulebooks.vue?vue&type=template&id=66b3d9e4&scoped=true"
import script from "./AdminRulebooks.vue?vue&type=script&lang=js"
export * from "./AdminRulebooks.vue?vue&type=script&lang=js"

import "./AdminRulebooks.vue?vue&type=style&index=0&id=66b3d9e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b3d9e4"]])

export default __exports__